/**
 * Utility function to get either the _id or _key property from an object.
 * Returns _id if present, otherwise returns _key.
 *
 * @param obj - Object that may have _id and/or _key properties
 * @returns The _id or _key value
 */
export function idOrKey<T extends { _id?: string; _key?: string }>(obj: T): string {
  return (obj._id || obj._key)!; /* eslint-disable-line @typescript-eslint/no-non-null-assertion */
}
